import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  ZUnsafeDataMap,
  zUnsafeDataMap,
} from "src/business/attribute/ZAttrValue";
import { ZValueCatalogCard } from "src/business/valueCatalog/ZValueCatalogCard";
import { dataParser } from "src/common/dataParser";
import { onError } from "src/common/onError";
import { ChangeFlag } from "src/components/ChangeFlag";
import { DeleteConfirm } from "src/components/DeleteConfirm";
import { MForm } from "src/components/MForm";
import { MFormStore } from "src/components/MForm/MFormStore";
import { PageBlocker } from "src/components/PageBlocker";
import { PageSubheader } from "src/components/PageSubheader";

type PropsValueCatalogRecForm = {
  title: string;
  okText: string;
  form: MFormStore;
  submit(dataMap: ZUnsafeDataMap): Promise<ZValueCatalogCard>;
  onSuccess(newCardData: ZValueCatalogCard): void;
  onDelete?(): Promise<void>;
};

export const ValueCatalogRecForm: React.FC<PropsValueCatalogRecForm> = observer(
  (props) => {
    const { title, okText, form, onSuccess, submit, onDelete } = props;
    const [deleting, setDeleting] = React.useState(false);
    const cvtAndSubmit = async (
      values: unknown,
    ): Promise<ZValueCatalogCard> => {
      const svData = dataParser(
        () => zUnsafeDataMap.parse(values),
        "Подготовка к записи",
      );
      return submit(svData);
    };
    const onFinish = async () => {
      const res: Error | ZValueCatalogCard = await form.onFinish(cvtAndSubmit);
      if (!(res instanceof Error)) {
        form.setAsUnchanged();
        onSuccess(res);
      }
    };
    return (
      <>
        <PageBlocker changed={() => form.isChanged} />
        <PageSubheader title={title}>
          <ChangeFlag changed={form.isChanged} />
          {onDelete && (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => setDeleting(true)}
            >
              Удалить
            </Button>
          )}
          <Button
            type="primary"
            loading={form.saving}
            onClick={() => onFinish().catch(onError)}
          >
            {okText}
          </Button>
        </PageSubheader>

        <MForm store={form} />

        {onDelete && (
          <DeleteConfirm
            content="Удалить карточку записи каталога?"
            open={deleting}
            close={() => setDeleting(false)}
            task={onDelete}
          />
        )}
      </>
    );
  },
);
